import { ChartTypeValue } from 'src/common/components/ChartTypeToggle/ChartTypeToggle';
import { UsageTypeValue } from 'src/common/components/UsageTypeSwitch/UsageTypeSwitch';

export const productSummaryGraphsQueries = {
  all: ['ProductSummaryGraphs'],
  subscriptionStatus: (tariffCode: string | null) => [
    ...productSummaryGraphsQueries.all,
    'Subscription Status',
    tariffCode,
  ],
  cumulativeUsage: (filters: {
    productCode: string;
    chartType: ChartTypeValue;
    usageType: UsageTypeValue;
  }) => [...productSummaryGraphsQueries.all, 'Cumulative Usage', filters],
};
